import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/reportsList', request)
}

export {get}
